import React, { Component } from "react";
import { connect } from "react-redux";
import {
    FormItem,
    ButtonItem,
    SelectItem,
    InputItem,
} from "../../../../../Components/Items";
import {
    Form as FormInitial,
    Row,
    Col,
    Select,
    Tooltip,
    Popconfirm,
} from "antd"
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import DynamicCardForm from "../../../../../Components/DynamicCardForm";

const { Option } = Select;


class TabRelaciones extends Component {
    render() {
        return (
            <div style={{ padding: '8px' }}>
                <Row gutter={[12, 12]}>
                    <DynamicCardForm title="RELACIONES CFDI" span={24}>
                        <FormInitial.List
                            name="relacionesCFDI"
                        >
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ name }, arrayKey) => (
                                        <Row key={arrayKey} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                                            <Col span={11}>
                                                <FormItem
                                                    name={[name, "tipoRelacion"]}
                                                    fieldKey={[arrayKey, "tipoRelacion"]}
                                                    required
                                                    margin
                                                    noStyle
                                                >
                                                    <SelectItem disabled={this.props.disabled} width='100%' placeholder="Tipo de Relación">
                                                        <Option value="01">Nota de crédito de los documentos relacionados</Option>
                                                        <Option value="02">Nota de débito de los documentos relacionados</Option>
                                                        <Option value="03">Devolución de mercancía sobre facturas o traslados previos</Option>
                                                        <Option value="04">Sustitución de los CFDI previos</Option>
                                                        <Option value="05">Traslados de mercancias facturados previamente</Option>
                                                        <Option value="06">Factura generada por los traslados previos</Option>
                                                        <Option value="07">CFDI por aplicación de anticipo</Option>
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col span={11}>
                                                <FormItem
                                                    name={[name, "uuid"]}
                                                    fieldKey={[arrayKey, "uuid"]}
                                                    pattern
                                                    required
                                                    margin
                                                    noStyle
                                                >
                                                    <InputItem
                                                        disabled={this.props.disabled}
                                                        placeholder="UUID"
                                                    />
                                                </FormItem>
                                            </Col>
                                            <Col span={2}>
                                                <div className="acciones-container">
                                                    {!this.props.disabled && (
                                                        <Popconfirm
                                                            title="¿Eliminar esta relación?"
                                                            onConfirm={() => remove(name)}
                                                            okText="Sí"
                                                            cancelText="No"
                                                        >
                                                            <Tooltip title="Eliminar">
                                                                <ButtonItem
                                                                    rojo2
                                                                    icon={<DeleteOutlined />}
                                                                    size="small"
                                                                    lessTime
                                                                />
                                                            </Tooltip>
                                                        </Popconfirm>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    ))}
                                    <div style={{ textAlign: 'center', marginTop: 10 }}>
                                        <ButtonItem
                                            type="primary"
                                            onClick={() => add()}
                                            icon={<PlusOutlined />}
                                            disabled={this.props.disabled}
                                            lessTime
                                        >
                                            Agregar Relación
                                        </ButtonItem>
                                    </div>
                                </>
                            )}
                        </FormInitial.List>
                    </DynamicCardForm>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.usuarioId,
    };
};

export default connect(mapStateToProps)(TabRelaciones);